<template>
  <div class="register">
    <div class="login__logo"></div>

    <!--    <div class="login__demo">Demo game</div>-->

    <passwordResetBox />

    <LoginBg />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import LoginBg from "@/components/login/LoginBg.vue";
import passwordResetBox from "@/components/passwordReset/passwordResetBox.vue";

export default {
  name: "ResetPassword",
  components: {
    LoginBg,
    passwordResetBox,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style>
</style>
